// extracted by mini-css-extract-plugin
module.exports = {"menu1":"MainMenu_menu1___Z_gQ","arrow":"MainMenu_arrow__d9IXl","link":"MainMenu_link__igzbj"};